import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDiscordMessageMutationVariables = Types.Exact<{
  input: Types.UpdateDiscordMessageInput;
}>;

export type UpdateDiscordMessageMutation = {
  __typename?: 'Mutation';
  updateDiscordMessage: {
    __typename?: 'DiscordMessage';
    id: any;
    content: string;
    embeds?: any | null;
    username?: string | null;
    avatarUrl?: string | null;
    tts: boolean;
    createdAt: any;
    updatedAt: any;
  };
};

export const UpdateDiscordMessageDocument = gql`
  mutation UpdateDiscordMessage($input: UpdateDiscordMessageInput!) {
    updateDiscordMessage(input: $input) {
      id
      content
      embeds
      username
      avatarUrl
      tts
      createdAt
      updatedAt
    }
  }
`;
export type UpdateDiscordMessageMutationFn = Apollo.MutationFunction<
  UpdateDiscordMessageMutation,
  UpdateDiscordMessageMutationVariables
>;

/**
 * __useUpdateDiscordMessageMutation__
 *
 * To run a mutation, you first call `useUpdateDiscordMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscordMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscordMessageMutation, { data, loading, error }] = useUpdateDiscordMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscordMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDiscordMessageMutation,
    UpdateDiscordMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDiscordMessageMutation,
    UpdateDiscordMessageMutationVariables
  >(UpdateDiscordMessageDocument, options);
}
export type UpdateDiscordMessageMutationHookResult = ReturnType<
  typeof useUpdateDiscordMessageMutation
>;
export type UpdateDiscordMessageMutationResult =
  Apollo.MutationResult<UpdateDiscordMessageMutation>;
export type UpdateDiscordMessageMutationOptions = Apollo.BaseMutationOptions<
  UpdateDiscordMessageMutation,
  UpdateDiscordMessageMutationVariables
>;
